import { getChannelSelectionItems } from '@commons/utils/translations';

import {
  isChannelFieldDisplayed,
  parseDeliveryDate,
  parseDeliveryTime,
} from './externalOrderHeaderFields';

/**
 * Selection displayed by the read-only header of an order past the draft status. The dropdowns of
 * the header resolve their selection against the items they are given, and a frozen order only
 * carries its own: its store as the perimeter knows it (the payload only carries its id and name,
 * and the channel field depends on its kitchen nature), its client as the side panel reads it —
 * the order carries its information flat — and its channel among the platform ones.
 *
 * @param {Object} externalOrder - The order as the detail service shapes it
 * @param {Object} perimeter - `{ stores, channels, hasMultipleChannels }` of the platform
 *
 * @returns {Object} Everything the header selectors and the client panel display
 */
export const buildOrderHeaderSelection = (
  externalOrder,
  { stores, channels, hasMultipleChannels },
) => {
  const selectedStore =
    stores.find(({ id }) => id === externalOrder.storeId) ?? externalOrder.store ?? null;

  const selectableChannels = getChannelSelectionItems(channels);

  const {
    id: externalClientId,
    name,
    externalReference,
    ...company
  } = externalOrder.externalClient ?? {};

  const externalClient = { id: externalClientId, name, externalReference, company };

  return {
    selectedStore,
    selectableStores: selectedStore ? [selectedStore] : [],
    isChannelDisplayed: isChannelFieldDisplayed({ hasMultipleChannels, store: selectedStore }),
    selectableChannels,
    selectedChannel: selectableChannels.find(({ id }) => id === externalOrder.channelId) ?? null,
    deliveryDate: parseDeliveryDate(externalOrder.deliveryDate),
    deliveryTime: parseDeliveryTime(externalOrder.deliveryTime),
    externalClient,
    selectableExternalClients: [externalClient],
  };
};
